import Vue from 'vue';

import ListingProductItem from '../components/search-listing-product-item.vue';

new Vue({
    el: '#template-search',

    delimiters: ['${', '}'],

    components: {
        ListingProductItem
    }
});